import React, { useEffect, useState } from "react";
import PropertyDetailsCard from "./PropertyDetailsCard";
import OfferAmount from "./OfferAmount";
import BuyerAgentInformation from "./BuyerAgentInformation";
import FinanceAndClosing from "./FinanceAndClosing";
import OfferSuccess from "../OfferSuccess";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { trackPageMount } from "@/utils/analytics";

const OfferWizard = ({ offerDetails, userId, cifId, cifDataDocuments,userRole,offerType }) => {
  const { offerPage } = offerDetails;
  const [accordionState, setAccordionState] = useState({
    accordion1: { close: false, disable: false, edit: false },
    accordion2: { close: true, disable: true, edit: false },
    accordion3: { close: true, disable: true, edit: false },
  });
  // const [bidAmount, setBidAmount] = useState(
  //   offerPage?.listingOfferDetails?.highestOfferAmount === 0
  //     ? offerPage?.listingOfferDetails?.minimumStartingOffer
  //     : offerPage?.listingOfferDetails?.highestOfferAmount
  // );
  // console.log(cifDataDocuments,'cif ini dex');

  const [bidAmount, setBidAmount] = useState(
    offerPage?.offerPricingInformation?.offerAmount
  );
  const [contigency, setContigency] = useState([]);
  const [offerUserDetail, setOfferUserDetail] = useState({});
  const [sellerConcession, setSellerConcession] = useState([]);
  const [offerDetailsData, setOfferDetailsData] = useState({});
  const [currentOfferAmountDetail, setCurrentOfferAmountDetails] = useState({});
  const [agent, setAgent] = useState(offerPage?.isAgent);
  const [offerSubmitted, setOfferSubmitted] = useState();
  const [submitData, setSubmitData] = useState();
  const [stateByName, setStataeByName] = useState("");
  const [individualLicenseStateCif, setIndividualLicenseCif] = useState("");
const [paylaodData,setPayloadData] = useState({})
  if (!offerDetails) {
    return (
      <div className="offer-loader p-5 mb-5">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      </div>
    );
  }
  useEffect(() => {
    setAgent(offerPage?.isAgent);
    setBidAmount(offerPage?.offerPricingInformation?.offerAmount);
    // if (offerPage?.listingOfferPriceDetails?.highestOfferAmount === 0) {
    //   setBidAmount(offerPage?.offerPricingInformation?.offerAmount);
    // } else {
    //   setBidAmount(offerPage?.listingOfferPriceDetails?.highestOfferAmount);
    // }
    stateMap();

    trackPageMount({
      pageName: "offer_wizard_mount",
      eventCategory: "New-Offer Wizard",
      eventSource: "on page mount",
      eventLabel: `Listing Id: ${offerPage?.listingId}`,
      eventParams: {
        offer_type: offerType === "PLACE_OFFER" ? "offer" : "backup_offer",
      },
    });
  }, [offerPage, cifDataDocuments,cifId]);

  useEffect(() => {
    if (cifDataDocuments) {
      const resp = offerPage?.stateListById?.filter(
        (data) =>
          data?.stateId === cifDataDocuments?.buyerAgent?.individualLicenseState
      );

      setIndividualLicenseCif(resp?.[0]?.stateName);
      // added to check the value in server
      console.log('in',resp,cifDataDocuments?.buyerAgent?.individualLicenseState);

    }
  }, [cifDataDocuments,cifId]);

  const stateMap = () => {
    const data = offerPage?.stateListById?.filter(
      (data) => data?.stateId === offerPage?.propertyDetails?.address?.state
    );
    setStataeByName(data?.[0]?.stateName);
     if (cifDataDocuments) {
      const resp = offerPage?.stateListById?.filter(
        (data) =>
          data?.stateId === cifDataDocuments?.buyerAgent?.individualLicenseState
      );

      setIndividualLicenseCif(resp?.[0]?.stateName);

    }
  };

  return (
    <div className="offer-wizard">
      {offerPage?.propertyDetails?.imageDetails?.[0]?.thumbnailUrl?.length >
        0 && (
        <PropertyDetailsCard
          propertyDetails={offerPage?.propertyDetails}
          listingOfferDetails={offerPage?.listingOfferPriceDetails}
        />
      )}
      {offerSubmitted ? (
        <OfferSuccess
          data={submitData}
          sellerConcession={sellerConcession}
          offerDetails={offerDetailsData}
          paylaodData={paylaodData}
        />
      ) : (
        <div className="offer-body cif-data-body">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <OfferAmount
              listingOfferDetails={offerPage?.listingOfferPriceDetails}
              accordionState={accordionState}
              listingId={offerPage?.listingId}
              offerPricingInformation={offerPage?.offerPricingInformation}
              sellerParameters={offerPage?.sellerParameters}
              bidAmount={bidAmount}
              setBidAmount={setBidAmount}
              setOfferDetails={setOfferDetailsData}
              setCurrentOfferAmountDetails={setCurrentOfferAmountDetails}
              setSellerConcession={setSellerConcession}
              offerDetails={offerDetailsData}
              currentOfferAmountDetail={currentOfferAmountDetail}
              setAccordionState={setAccordionState}
              offerType={offerType}
            />
            <BuyerAgentInformation
              accordionState={accordionState}
              bidUserDetail={offerPage?.bidUserDetail}
              preOfferCifEnabledFlag={offerPage?.preOfferCifEnabledFlag}
              bidQuestionariesEnabled={offerPage?.bidQuestionariesEnabled}
              isAgent={agent}
              defaultState={offerPage?.propertyDetails?.address?.state}
              setContigency={setContigency}
              defaultPaymentType={
                offerPage?.sellerParameters?.financingAndClosingParameters
                  ?.defaultPaymentType
              }
              listingId={offerPage?.listingId}
              bidAmount={bidAmount}
              setOfferUserDetail={setOfferUserDetail}
              offerDetails={offerDetailsData}
              setOfferDetails={setOfferDetailsData}
              setAgent={setAgent}
              setAccordionState={setAccordionState}
              stateByName={stateByName}
              cifDataDocuments={cifDataDocuments}
              individualLicenseStateCif={individualLicenseStateCif}
               offerType={offerPage?.offerType}
            />
            <FinanceAndClosing
              accordionState={accordionState}
              sellerParameters={offerPage?.sellerParameters}
              listingId={offerPage?.listingId}
              bidAmount={bidAmount}
              contigency={contigency}
              afbaUrl={offerPage?.afBADocumentPath}
              isAgent={agent}
              propertyId={offerPage?.propertyId}
              listingStatus={offerPage?.listingStatus}
              offerType={offerPage?.offerType}
              offerDetails={offerDetailsData}
              setOfferDetails={setOfferDetailsData}
              currentOfferAmountDetail={currentOfferAmountDetail}
              setCurrentOfferAmountDetails={setCurrentOfferAmountDetails}
              offerUserDetail={offerUserDetail}
              sellerConcession={sellerConcession}
              userId={userId}
              setOfferSubmitted={setOfferSubmitted}
              setSubmitData={setSubmitData}
              setAccordionState={setAccordionState}
              cifId={cifId}
              propertyDetails={offerPage?.propertyDetails}
              setPayloadData={setPayloadData}
              userRole={userRole}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferWizard;
